/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_File_Content_MismatchInputs */

const en_error_file_content_mismatch = /** @type {(inputs: Error_File_Content_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The content of the file does not match its extension. Save it again as an Excel file (.xlsx).`)
};

/**
* | output |
* | --- |
* | "The content of the file does not match its extension. Save it again as an Excel file (.xlsx)." |
*
* @param {Error_File_Content_MismatchInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_file_content_mismatch = /** @type {((inputs?: Error_File_Content_MismatchInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_File_Content_MismatchInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_file_content_mismatch(inputs)
});